const map = {
	"./1.jpeg": 22780,
	"./2.jpeg": 92029,
	"./3.jpeg": 10710,
	"./4.jpeg": 93983,
	"./5.jpeg": 47112,
	"./intro-2.jpeg": 19110,
	"./intro-3.jpeg": 50445
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6974;